import type { CarCategoryFindInterface } from '@zaoblako/shared/modules/cctv/dtos/car-category/car-category-find.dto';

import { catchError, map, type Observable, of } from 'rxjs';

/** Resolves tenant default category only when it is present in the already filtered list */
export const findDefaultCarCategoryInList = (
  findDefault: () => Observable<CarCategoryFindInterface>,
  categories: CarCategoryFindInterface[]
): Observable<CarCategoryFindInterface | null> =>
  findDefault().pipe(
    map((defaultCategory) => {
      if (!defaultCategory?.id || !categories.length) {
        return null;
      }

      return categories.find((category) => category.id === defaultCategory.id) ?? null;
    }),
    catchError(() => of(null))
  );
